import React, { FC, memo } from 'react';
import { CarGalleryProps } from '.';
import Button from '@components/Button';
import { useTranslations } from '@hooks/useTranslations';
import { useGetGalleryImages } from '@hooks/useGetGalleryImages';
import CarGalleryList from './CarGalleryList';
import { ImageViewType } from '../../constants/enums';

const CarGalleryTemplate: FC<CarGalleryProps> = memo(
    ({
        className,
        arrows,
        defaultArrows,
        dots,
        setSmallImage,
        imageSet: parentImageSet,
        allowDefaultConfigurationImages,
        imageItems: parentImageItems,
    }) => {
        const { t } = useTranslations();

        const {
            imageItems,
            isExterior,
            isInterior,
            isImagesExists,
            isSelectedExterior,
            isSelectedInterior,
            setImageViewType,
        } = useGetGalleryImages({
            allowDefaultConfigurationImages,
        });

        return (
            isImagesExists && (
                <div className={className}>
                    <CarGalleryList
                        images={parentImageItems || imageItems}
                        arrows={arrows}
                        defaultArrows={defaultArrows}
                        setSmallImage={setSmallImage}
                        dots={dots}
                    />

                    {!parentImageSet && (
                        <div className="button-wrapper">
                            {isExterior && (
                                <Button
                                    className={isSelectedExterior && 'active'}
                                    onClick={() => setImageViewType(ImageViewType.EXTERIOR)}
                                >
                                    {t('toggleView.exterior')}
                                </Button>
                            )}
                            {isInterior && (
                                <Button
                                    className={isSelectedInterior && 'active'}
                                    onClick={() => setImageViewType(ImageViewType.INTERIOR)}
                                >
                                    {t('toggleView.interior')}
                                </Button>
                            )}
                        </div>
                    )}
                </div>
            )
        );
    }
);
CarGalleryTemplate.displayName = 'CarGalleryTemplate';
export default CarGalleryTemplate;
